import { ConfirmDialog } from '@roc/ui';
import { useDrawsStore } from '@roc/feature-draws';
import { observer } from 'mobx-react';

export const ResolveDraw = observer(({ loanId, drawId, afterActionExecuted }) => {

  const { drawStore: { drawActionsStore } } = useDrawsStore();

  const confirmHandler = () => {
    drawActionsStore.resolveDraw(drawId, afterActionExecuted);
  }

  return (
    <ConfirmDialog
      open={drawActionsStore.isResolveDrawDialogOpen}
      confirmButtonText='Confirm'
      handleClose={() => drawActionsStore.setIsResolveDrawDialogOpen(false)}
      handleCancel={() => drawActionsStore.setIsResolveDrawDialogOpen(false)}
      handleConfirm={confirmHandler}
      title={'Resolve Draw'}
      body={`Are you sure you want to resolve the current draw?`}
    />
  );
});
